import { gql } from '@eti/schema-types';

export const UPDATE_TRIP_BEFORE_RESERVATION = gql(/* GraphQL */ `
  mutation UpdateTripBeforeReservation {
    updateSelectedTripBeforeReservation {
      success
      priceLockFailure {
        failureCode
        selectionKey
      }
    }
  }
`);

export const UPDATE_SESSION = gql(/* GraphQL */ `
  mutation updateSession {
    updateSession {
      success
    }
  }
`);
